import script from "./numeric-input.vue?vue&type=script&setup=true&lang=ts"
export * from "./numeric-input.vue?vue&type=script&setup=true&lang=ts"

const __exports__ = script;

export default __exports__